import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../../../../context/contextAuth";
import { useDesign } from "../../../../../context/contextDesign";
import { useChat } from "../../../../../context/contextChat";
import { useState } from "react";
import CustomModal from "../../../../../components/modal";
import hexToRGBA from "../../../../../utils/hexToRGBA";

export default function ServiceAccordion({ findings, regions }) {
  const { bHeightVal } = useDesign();
  if (!findings || typeof findings !== "object") return null;

  return (
    <div
      className="accordion overflow-y-auto pe-4"
      id="findingsAccordion"
      style={{ maxHeight: `calc(${bHeightVal} - 6vh)` }}
    >
      {Object.entries(findings).map(([key, finding], index) => (
        <FindingCard
          key={key}
          findingKey={key}
          finding={finding}
          regions={regions}
          index={index}
        />
      ))}
    </div>
  );
}

function FindingCard({ findingKey, finding, regions, index }) {
  const { user } = useAuth();
  const service_name = useParams().service;
  const safeRegions = regions ? regions : [];
  const isDisabled = safeRegions.length == 0;
  const collapseId = `collapse-${index}`;
  const headingId = `heading-${index}`;

  const { setPrompt, setShowChat } = useChat();
  const [vulTable, setVulTable] = useState([]);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
    level: "",
    remediation: "",
  });
  const [showModal, setShowModal] = useState(false);


  const handleAIAssistance = (content) => {
    if (!content) return;
    const formattedPrompt = `Give me step-by-step remediation action plan for the below misconfiguration Details:
    
Title: ${content.title}
Description: ${content.description}
Level: ${content.level}
${content.remediation ? "Remediation: " + content.remediation : ""}`.trim();
    setPrompt(formattedPrompt);
    setShowChat(true);
    setShowModal(false);
  };

  const levelColor =
    finding.level === "danger"
      ? "danger"
      : finding.level === "warning"
        ? "warning"
        : "success";

  return (
    <div className="accordion-item mb-3 border">
      <div className="h3 accordion-header" id={headingId}>
        <button
          // className={`accordion-button collapsed fw-semibold ${isDisabled ? "disabled opacity-50" : ""}`}
          className="accordion-button collapsed fw-semibold"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${collapseId}`}
          aria-expanded="false"
          aria-controls={collapseId}
        >
          <div className="d-flex flex-wrap justify-content-between w-100">
            <div className="me-3 text-capitalize"
            // onClick={() => !isDisabled && Navigate(`/dashboard/cloud-dashboard/aws/service/${service_name}/regions/${findingKey}`)}
            >
              {finding.description || findingKey}

              <button
                className="btn btn-sm btn-light border shadow-sm rounded-pill px-3 ms-4"
                style={{ fontSize: '0.7rem', fontWeight: 'bold' }}
                onClick={() => {
                  setModalContent({
                    title: finding.description || findingKey,
                    description: finding.rationale,
                    level: finding.level,
                    remediation: finding.remediation || "",
                  });
                  setShowModal(true);
                }}
              >
                <i className="bi bi-stars text-primary me-1"></i> Analyze
              </button>
            </div>

            <div className={`badge bg-${levelColor} px-2 me-4`} style={{ width: "73px" }}>
              {finding.level}
            </div>
          </div>
        </button>
      </div>

      <div
        id={collapseId}
        className="accordion-collapse collapse"
        aria-labelledby={headingId}
        data-bs-parent="#findingsAccordion"
      >
        <div className="accordion-body bg-light">
          <div className="d-flex flex-wrap justify-content-between">
            <div className="w-75">
              {finding.rationale && (
                <Section title="Description" content={finding.rationale} />
              )}

              {finding.remediation && (
                <Section title="Remediation" content={finding.remediation} />
              )}

              {Array.isArray(finding.compliance) && finding.compliance.length > 0 && (
                <section className="mb-3">
                  <h6 className="fw-bold">Compliance</h6>
                  <ul className="mb-0">
                    {finding.compliance.map((comp, i) => {
                      if (typeof comp === "string") {
                        return <li key={i}>{comp}</li>;
                      }

                      if (typeof comp === "object" && comp !== null) {
                        return (
                          <li key={i}>
                            <span className="fw-semibold">{comp.name}</span>
                            {comp.version && <span> (v{comp.version})</span>}
                            {comp.reference && <span> — Ref {comp.reference}</span>}
                          </li>
                        );
                      }

                      return null;
                    })}
                  </ul>
                </section>
              )}

              {Array.isArray(finding.references) && finding.references.length > 0 && (
                <section className="mb-3">
                  <h6 className="fw-bold">References</h6>
                  <ul className="mb-0">
                    {finding.references.map((ref, i) => {
                      if (typeof ref === "string") {
                        return (
                          <li key={i}>
                            <a href={ref} target="_blank" rel="noreferrer">
                              {ref}
                            </a>
                          </li>
                        );
                      }

                      if (typeof ref === "object" && ref !== null) {
                        return (
                          <li key={i}>
                            <span className="fw-semibold">{ref.name}</span>
                            {ref.version && <span> (v{ref.version})</span>}
                            {ref.reference && <span> — Ref {ref.reference}</span>}
                          </li>
                        );
                      }

                      return null;
                    })}
                  </ul>
                </section>
              )}
            </div>
            <div>
              <div className="gap-2 small text-muted" style={{ width: "118px", lineHeight: "0.8rem" }}>
                <p>Checked: {finding.checked_items}</p>
                <p>Flagged: {finding.flagged_items}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Misconfiguration Analysis"
        footer={
          <div className="d-flex gap-3 py-2">
            <button
              className="btn btn-light fw-bold"
              onClick={() => setShowModal(false)}>
              Dismiss
            </button>
            <button
              className="btn btn-primary px-4 fw-bold"
              onClick={() => handleAIAssistance(modalContent)}>
              <i className="bi bi-stars me-2"></i>
              Generate Mitigation Plan
            </button>
          </div>
        }
      >
        <div className="p-2" style={{ 
          whiteSpace: "pre-wrap", 
          fontSize: 13, 
          lineHeight: "1.6", 
          color: "#444" 
        }}>
          <div className="fw-bold mb-3 text-light">{modalContent.title}</div>
          <div className="fw-bold mb-3 text-light">Description: {modalContent.description}</div>
          <div className="fw-bold mb-3 text-light">Level: {modalContent.level}</div>
          <p className="mt-3 small text-light">
            Clicking "Generate Mitigation Plan" will send this misconfiguration data to the AI engine for a customized remediation strategy based on your role as {user?.designation}.
          </p>
        </div>
      </CustomModal>
    </div>
  );
}

function Section({ title, content }) {
  return (
    <section className="mb-3">
      <h6 className="fw-bold">{title}</h6>
      <p className="mb-0">{content}</p>
    </section>
  );
}

